import React from 'react'

import Layout from '../components/layout'
import PagePrimaryHero from '../components/PagePrimaryHero'


export default () => {
  return (
    <Layout>
      <PagePrimaryHero>
        <div className="col-sm-10 col-lg-8 col-xl-6 text-center">
          <h1 className="font-alt display-1 mb-3 text-white">
            404
          </h1>
        <div className="divider bg-white mx-auto"></div>
          <p className="lead text-warning mt-4 mb-4 text-center">
            Page Not found
          </p>
          <p className="text-white">
            We are sorry, but the page you are looking for does not exist.
          </p>
        </div>
      </PagePrimaryHero>
    </Layout>
  )
}